const MODAL_CLASS = 'm-modal';
const LINK_CLASS = 'js-modal-link';
const EXIT_CLASS = 'js-modal-exit';
const OPEN_CLASS = 'is-open';
const MODAL_OPEN_CLASS = 'is-modal-open';
export const initModals = (root = document) => {
    initStandardModals(root);
    initDynamicModals(root);
    document.body.addEventListener('click', (event) => {
        const target = event.target;
        if (target.tagName.toLowerCase() === 'img' && target.dataset.modal) {
            event.preventDefault();
            const modal = document.getElementById(target.dataset.modal);
            if (modal) {
                showModal(modal);
            }
            return;
        }
        const modalLink = target.closest(`.${LINK_CLASS}`);
        if (modalLink && modalLink.dataset.modal) {
            event.preventDefault();
            const modal = document.getElementById(modalLink.dataset.modal);
            if (modal) {
                showModal(modal);
            }
            return;
        }
        const modalExit = target.closest(`.${EXIT_CLASS}`);
        if (modalExit) {
            event.preventDefault();
            const modal = modalExit.closest(`.${MODAL_CLASS}`);
            if (modal) {
                hideModal(modal);
            }
        }
    });
};
const initDynamicModals = (root) => {
    const elements = root.querySelectorAll('article .m-stage__text img');
    if (!elements.length) {
        return;
    }
    elements.forEach((img) => {
        const parentLink = img.closest('a[href$=".jpg"], a[href$=".png"], a[href$=".jpeg"]');
        const largerImageUrl = parentLink ? parentLink.href : null;
        if (largerImageUrl && largerImageUrl !== img.src) {
            setupImageModal(img, largerImageUrl);
        }
    });
};
let modalCounter = 0;
const setupImageModal = (img, largerImageUrl) => {
    const modalId = `modal-blog-image-${modalCounter++}`;
    img.dataset.modal = modalId;
    img.dataset.imageSrc = img.src;
    img.dataset.imageAlt = img.alt;
    const parentLink = img.closest('a[href$=".jpg"], a[href$=".png"], a[href$=".jpeg"]');
    const largerImageSrc = parentLink ? parentLink.href : img.src;
    img.dataset.largerImageSrc = largerImageSrc;
    const modal = createImageModal(modalId, img, largerImageSrc);
    const footer = document.querySelector('footer');
    if (modal && footer) {
        footer.after(modal);
    }
};
const createImageModal = (modalId, img, imageSrc) => {
    const imgAlt = img.alt;
    const modal = document.createElement('div');
    modal.classList.add(MODAL_CLASS);
    modal.id = modalId;
    modal.setAttribute('aria-hidden', 'true');
    modal.innerHTML = `
        <div class="m-modal-bg ${EXIT_CLASS}"></div>
        <div class="m-modal-container">
            <button class="m-modal-close ${EXIT_CLASS}">
                <svg class="c-icon" width="24" height="23">
                    <use href="#close"/>
                </svg>
            </button>
            <div class="m-modal__body">
                <img src="${imageSrc}" alt="${imgAlt}">
            </div>
        </div>
    `;
    return modal;
};
const initStandardModals = (root) => {
    const modals = root.querySelectorAll(`.${MODAL_CLASS}:not(.initialized)`);
    modals.forEach((modal) => {
        modal.classList.add('initialized');
    });
};
export const showModal = (modal) => {
    hideModals();
    modal.classList.add(OPEN_CLASS);
    modal.setAttribute('aria-hidden', 'false');
    document.documentElement.classList.add(MODAL_OPEN_CLASS);
};
export const hideModal = (modal) => {
    modal.classList.remove(OPEN_CLASS);
    modal.setAttribute('aria-hidden', 'true');
    document.documentElement.classList.remove(MODAL_OPEN_CLASS);
};
export const hideModals = (root = document) => {
    root.querySelectorAll(`.${MODAL_CLASS}`).forEach((modal) => {
        hideModal(modal);
    });
};
